@if (elemDef) {
  <div
    class="child-tile"
    [attr.data-color]="displayColor">
    <div
      class="icon"
      [innerHtml]="'<i class=\'fa-regular fa-'+displayIcon+'\'>'"
    ></div>
  </div>
}
